import React, { useState, useRef } from "react";
import { connect } from "react-redux";

import {
  EditOutlined,
  CalendarOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Button, Checkbox, Col, DatePicker, Input, Modal, Row, Select, Space, Switch, Table, Tooltip } from "antd";


const { Option } = Select;

export const UpdatePurchaseOrder = (props) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: <Tooltip title={t("Retailer Name")}>{t("Retailer Name")}</Tooltip>,
      ellipsis: true,
      dataIndex: "retailerName",
    },
    {
      title: <Tooltip title={t("Product")}>{t("Product")}</Tooltip>,
      ellipsis: true,
      dataIndex: "product",
    },
    {
      title: <Tooltip title={t("Quantity")}>{t("Quantity")}</Tooltip>,
      ellipsis: true,
      dataIndex: "quantity",
    },
    {
      title: <Tooltip title={t("Order Date")}>{t("Order Date")}</Tooltip>,
      ellipsis: true,
      dataIndex: "orderDate",
    },
    {
      title: <Tooltip title={t("Action")}>{t("Action")}</Tooltip>,
      ellipsis: true,
      dataIndex: "action",
    },
  ];

  const data = [
    {
      key: "1",
      retailerName: "Retailer 1",
      product: "Product 1",
      quantity: "1",
      orderDate: "10/10/2019",
      action: <button class="primary-btn"> {t("Confirm")} </button>,
    },
    {
      key: "1",
      retailerName: "Retailer 1",
      product: "Product 1",
      quantity: "1",
      orderDate: "10/10/2019",
      action: <button class="primary-btn"> {t("Confirm")} </button>,
    },
  ];

  return (
    <div className="form__fields">
      <div className="row magento__mapping">
        <div className="col-md-12">
          <div className="heading__block">
            <h4 class="workarea__heading mt-0 mb-0">
              {" "}
              {t("Update Purchase Order")}{" "}
            </h4>
          </div>
        </div>
        <div className="divForm">
          <Table columns={columns} dataSource={data} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdatePurchaseOrder);
